/* eslint eslint-comments/disable-enable-pair: error */
/* eslint-disable no-undef, no-unused-vars */

import './scss/main.scss';
import './js/main';

/* eslint-enable no-undef, no-unused-vars */
